namespace AgerLMS.Administration.Repositories {
    export interface SiteSettingRetrieveResponse extends Serenity.RetrieveResponse<SiteSettingsRow> {
        SettingData?: { [key: string]: any };
        Properties?: Serenity.PropertyItem[];
    }
}
